// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"EditFeatureRequest_inputContainer__rDWeh"};